<div class="add_new_md">
    
    <form [formGroup]="addFreeSubscriptionForm" (ngSubmit)="saveDiscount()">
       <div class="add-header">
        <div class="md-header">
            <div class="row">
                <div class="col-sm-6">
                    Add free subscription
                </div>
                <div class="col-sm-3">
                    
                </div>
                <div class="col-sm-3" style="text-align: right;margin-top: -5px;">
                    <button type="button" class="cenl_btn" (click)="closePopup()"><span class="material-icons cenl_btn_icon ">
                        close
                        </span></button>
                </div>
            </div>
        </div>
       </div>
           
        
        <div>
            <div class="ad_ox">
                <div class="form-group" >
                    <br>
                    <label for="Description">Subscription type*</label>
                    <div class="add_crt">
                        <div class="row">
                            <div class="col-sm-6">
                                <input type="radio" id="test3" value="business" formControlName="subsType"  >
                                <label for="test3">Business</label>
                            </div>
                            <div class="col-sm-6">
                                <input type="radio" id="test4" value="employee" formControlName="subsType" >
                                <label for="test4">Employee</label>
                            </div>
                            
                        </div>
                    </div>
                </div>
           
              
             
              
           
                <!-- <strong *ngIf="addDiscountForm.get('minimumCartValue').invalid && addDiscountForm.get('minimumCartValue').touched" style="color: 'red'; font-size: small">Enter valid minimum cart value</strong> -->
                <div class="form-group">
                    <label for="access">Duration (in months)*</label>
                    <input  smDecimalOnly  type="number" id="access" autocomplete="off" formControlName="duration" placeholder="Enter duration in months">
                </div>
                
              
               
                <!-- <strong *ngIf="addDiscountForm.get('description').invalid && addDiscountForm.get('description').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
            </div>
        </div>

        <div class="add_footer">
            <div class="md-footer">
                <div class="row">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="button" class="footer_button_cancel" (click)="closePopup()">Cancel</button>
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="submit" class="footer_button" [disabled]="addFreeSubscriptionForm.invalid">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
